module.exports = __webpack_public_path__ + "static/media/security.ce35c56c.svg";